// DS: CR11A
import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import ImageDumbView from './Image';
import JournalDumbView from './Journal';
import StatusDumbView from './Status';
import PollDumbView from './Poll';
import CommissionDumbView from './Commission';
import UnknownDumbView from './Unknown';
import ErrorBoundary from '../../ErrorBoundary';
import LiteratureDumbView from './Literature';
import { useDumboCommon } from './useDumbo';
const DeviationDumbView = (props)=>{
    const DumboReturn = useDumboCommon(props);
    if (DumboReturn) {
        return DumboReturn;
    }
    let DumbView;
    switch(getDeviationType(props.deviation)){
        // these types all have guaranteed thumb image
        case DeviationTypes.IMAGE:
        case DeviationTypes.PDF:
        case DeviationTypes.FILM:
        case DeviationTypes.TIER:
            DumbView = ImageDumbView;
            break;
        case DeviationTypes.JOURNAL:
            DumbView = JournalDumbView;
            break;
        case DeviationTypes.LITERATURE:
            DumbView = LiteratureDumbView;
            break;
        case DeviationTypes.STATUS:
            DumbView = StatusDumbView;
            break;
        case DeviationTypes.POLL:
            DumbView = PollDumbView;
            break;
        case DeviationTypes.COMMISSION:
            DumbView = CommissionDumbView;
            break;
        default:
            DumbView = UnknownDumbView;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Dumbo",
        style: {
            width: props.width,
            height: props.height
        }
    }, /*#__PURE__*/ React.createElement(DumbView, props));
};
DeviationDumbView.displayName = 'DeviationDumbView';
export default DeviationDumbView;
